import React, { FC, forwardRef } from "react";
import { Control } from "react-hook-form";

import InputBase, { InputProps } from "@/components/ui/Form/Input/InputBase";
import InputControlled from "@/components/ui/Form/Input/InputControlled";

import "./input.css";

interface DynamicInputProps extends InputProps {
  control?: Control<any>;
}

const Input = forwardRef<HTMLInputElement, DynamicInputProps>(function Input(args, ref) {
  return args?.control ? <InputControlled control={args.control} {...args} /> : <InputBase {...args} ref={ref} />;
});

export default Input;
